export const productItem = `      
      company
      id
      comloc
      type
      sku
      name
      version
      description
      qtyOnHand
      qtyAvailable
      attributes {
        value
        type
      }
      settings {
        items {
        settingId
        value
        }
      nextToken
      }
      status
      price
      deposit
      categories {
        items {
          id
          category {
            id
          }
        }
        nextToken
      }
      dimensions {
        height
        width
        weight
        length
      }
      image {
        id
        name
        url
      }
      stockItems(limit: 1000) {
        items {
          company
          id
        }
        nextToken
      }
      media {
        items {
          id
          media {
            id
            name
            url
          }
        }
        nextToken
      }`;



export const listProducts = `query ListProducts(
  $company: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelProductFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProducts(
    company: $company
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
        ${productItem}
    }
    nextToken
  }
}
`;

export const listProductsByType = /* GraphQL */ `
  query ListProductsByType(
    $company: ID
    $typeName: ModelProductListProductsByTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductsByType(
      company: $company
      typeName: $typeName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ${productItem}
    }
    nextToken
  }
}
`;
export const listProductsByCategory = /* GraphQL */ `
  query ListProductsByCategory(
    $company: ID
    $categoryIdSeq: ModelProductCategoryByCategorySeqCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductsByCategory(
      company: $company
      categoryIdSeq: $categoryIdSeq
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        categoryId
        product {
         ${productItem}
        }
      }
      nextToken
    }
  }
`;

export const searchProductCategorys = /* GraphQL */ `
  query SearchProductCategorys(
    $filter: SearchableProductCategoryFilterInput
    $sort: SearchableProductCategorySortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductCategorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        categoryId
        product {
         ${productItem}
        }
      }
      nextToken
      total
    }
  }
`;

export const searchProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: SearchableProductSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ${productItem}
      }
      nextToken
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($company: ID!, $id: ID!) {
    getProduct(company: $company, id: $id) {
     ${productItem}
    }
  }
`;

export const listCategoriesByProduct = /* GraphQL */ `
  query ListCategoriesByProduct(
    $company: ID
    $productId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoriesByProduct(
      company: $company
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        categoryId
        productId
        seq
        createdAt
        updatedAt
        product {
           ${productItem}
        }
        category {
          id
          name
        }
      }
      nextToken
    }
  }
`;

export const listCrossSellByParentId = /* GraphQL */ `
  query ListCrossSellByParentId(
    $company: ID
    $parentId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCrossSellProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCrossSellByParentId(
      company: $company
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        parentId
        productId
        seq
        createdAt
        updatedAt
        
        product {
          ${productItem}
        }
      }
      nextToken
    }
  }
`;